import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function BotonCertificado({
  loadingCertificado,
  handleCertificadoInfo,
}) {
  return (
    <>
      {loadingCertificado ? (
        <LoadingButton
          loading
          variant="contained"
          sx={{
            width: "118.5px",
            height: "40px",
            marginBottom: 3,
          }}
        />
      ) : (
        <Button
          variant="contained"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 3,
            color: "white",
            padding: "8px 8px 6px 8px",
            fontWeight: "bold",
            height: "40px",
            textTransform: "none",
            fontSize: "15.5px",
          }}
          onClick={handleCertificadoInfo}
        >
          Certificado
          <DownloadIcon sx={{ fontSize: "20px", marginLeft: "4px" }} />
        </Button>
      )}
    </>
  );
}
